var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dp-container',{staticClass:"dp-route-loading"},[_c('dp-section-loader',{attrs:{"active":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }